<template>
    <table class="gift-registration-order-summary">
        <thead>
            <tr>
                <th class="name">&nbsp;</th>
                <th class="ex-vat">Ex. VAT</th>
                <th class="value">Inc. VAT</th>
            </tr>
        </thead>
        <tbody>
            <!--<tr class="gift" v-if="item.type=='physical' && prices.gift || prices.prepaid">
                <td class="name">Gift Price <div class="sub" v-if="prices.prepaid">prepaid stock, not charged</div></td>
                <td class="ex-vat" v-if="!prices.prepaid">{{ pricesExVat.gift | toCurrency }}</td>
                <td class="value" v-if="!prices.prepaid">{{ prices.gift | toCurrency }}</td>
                
                <td class="ex-vat" v-if="prices.prepaid"><i>{{ pricesExVat.prepaid | toCurrency }}</i></td>
                <td class="value" v-if="prices.prepaid"><i>{{ prices.prepaid | toCurrency }}</i></td>
            </tr>-->
            <tr v-if="item.type=='voucher'">
                <td class="name">Voucher Value</td>
                <td class="ex-vat">{{ pricesExVat.voucher | toCurrency }}</td>
                <td class="value">{{ prices.voucher | toCurrency }}</td>
            </tr>
            <tr v-if="item.type=='physical' && prices.notecard && prices.notecard">
                <td class="name">Greeting Card</td>
                <td class="ex-vat">{{ pricesExVat.notecard | toCurrency }}</td>
                <td class="value">{{ prices.notecard | toCurrency }}</td>
            </tr>
            <tr v-if="item.type=='physical' && platform=='gifting' && prices.admin">
                <td class="name">Pick & Pack</td>
                <td class="ex-vat">{{ pricesExVat.admin | toCurrency }}</td>
                <td class="value">{{ prices.admin | toCurrency }}</td>
            </tr>
            <tr v-if="item.type=='voucher' && prices.admin">
                <td class="name">Admin Fee</td>
                <td class="ex-vat">{{ pricesExVat.admin | toCurrency }}</td>
                <td class="value">{{ prices.admin | toCurrency }}</td>
            </tr>
            <tr v-if="item.type=='physical'">
                <td class="name">Shipping</td>
                <td class="ex-vat">{{ pricesExVat.shipping | toCurrency }}</td>
                <td class="value">{{ prices.shipping | toCurrency }}</td>
            </tr>   
            <tr class="total">
                <td class="name"><span v-if="type === 'create'">Total Price To Pay</span><span v-else>Total Price Paid</span></td>
                <td class="ex-vat">{{ pricesExVat.total | toCurrency }}</td>
                <td class="value">{{ prices.total | toCurrency }}</td>
            </tr>
        </tbody>
    </table>
</template>


<script>
export default {
    name: "PaymentSummaryTable",
    props: {
        prices: Object,
        pricesExVat: Object,
        item: Object,
        platform: {type: String, default: 'gifting'},
        type: String,
    },
    data() {
        return {
            loaded: false,
        }
    },
    methods: {
        async fetchData() {
            this.loaded = true;
        },
    },
    mounted() {
		this.fetchData();
	},
    computed: {
		team() {
			return this.$store.state.team.detail;
		},
        /*showTotal() {
            let items = 0;
            for (const price in this.prices) {
                if (this.prices[price]) items++;
            }
            if (items > 2 || items==0) return true;
            else return false;
        }*/
    },
    watch: {
        
	}
}
</script>